import { Fragment } from "react";
import { SpinnerCircular } from "spinners-react";
import { Dialog } from "../../components/CommonComponents/Dialog/Dialog";
import { ShowField } from "../../components/ViewApplication/ViewApplication";
import {
  TApplication,
  useApplicationFormSteps,
} from "../../hooks/applications.hooks";

export function RenderApplication({
  application,
  onClose,
}: {
  application: TApplication & Record<string, unknown>;
  onClose: () => unknown;
}) {
  const {
    data: result,
    isError,
    isFetching,
  } = useApplicationFormSteps(Number(application?.name_of_service));

  const steps = result?.data || [];
  let i = 0;
  let toRender = (
    <>
      {(steps || [])
        .filter((e) => !["Documents", "NOC"].includes(e.type))
        .map((e) => (
          <Fragment key={`step-${e.id}`}>
            {e.fields?.map((e) => (
              <ShowField
                field={e}
                index={++i}
                key={`field-${e.id}`}
                data={application || {}}
              />
            ))}
          </Fragment>
        ))}
    </>
  );

  if (isFetching || isError) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {isError ? (
          <p>Something went wrong while fetching application info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  }
  return (
    <Dialog onClose={onClose} open className="md:w-4/5 lg:w-3/5 md:h-4/5">
      <div className="p-4 md:p-8 h-full flex overflow-auto flex-col">
        <div className="mb-8 flex justify-center items-center">
          <h4 className="m-0 grow text-center text-2xl font-bold">
            {"Edit Application Preview"}
          </h4>
          <button className="text-xl" onClick={onClose}>
            <i className="fa fa-close"></i>
          </button>
        </div>
        <div className="w-full grow overflow-auto">{toRender}</div>
      </div>
    </Dialog>
  );
}
